import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/marketing-health")({
  component: lazyRouteComponent(() => import("./-pages/admin.marketing-health")),
  head: () => ({
    meta: [
      { title: "Marketing Health · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
